import { EventEmitter, Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class HttpRequestCheckAppVersionService {
  public appVersionError$ = new EventEmitter<void>()
}
